import { render, staticRenderFns } from "./SportelloContrattiTerminatiView.vue?vue&type=template&id=275eabd9&"
import script from "./SportelloContrattiTerminatiView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiTerminatiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports